import type { ComponentType } from 'react'

import { StoryFormWithAttachment } from '@/components/form/StoryForm.tsx'
import { useStoryInteractionContext } from '@/contexts/StoryInteractionContext.tsx'

export const withFormToggler = (WrappedComponent: ComponentType<{ story: Story }>) => {
  return ({ story }: Omit<FormProps, 'storyChildrenHandlers'>) => {
    const { getIsStoryFormOpen, toggleStoryFormOpen } = useStoryInteractionContext()

    return (
      <>
        {getIsStoryFormOpen(story.id) ? (
          <StoryFormWithAttachment storyId={story.id} />
        ) : (
          // biome-ignore lint/a11y/useKeyWithClickEvents:
          <div onClick={() => toggleStoryFormOpen(story.id)}>
            <WrappedComponent story={story} />
          </div>
        )}
      </>
    )
  }
}
